import clsx from 'clsx';

/**
 * -----------------------------------------------------------------------------
 * Styles for the loading indicator on the session profile picture.
 * You need to provide it a `className` with `w-` and `h-` classes.
 */
export function CircularLoader({ className }: { className?: string }) {
  return <div className={clsx('simple-circular-loader', className)} />;
}
